"use client";
 
import React from "react";
 
type ClientCard = {
  label?: string;
  name?: string;
  description?: string;
};
 
type SkewCard = {
  title?: string;
  description?: string;
};
 
type CaseStudiesSkewSatusCardsSectionProps = {
  clients?: ClientCard[]; // left side data
  skewCards?: SkewCard[]; // right side data
};
 
const CaseStudiesSkewSatusCardsSection: React.FC<
  CaseStudiesSkewSatusCardsSectionProps
> = ({ clients = [], skewCards = [] }) => {
  return (
    <section
      className={`xl:section-background-filler relative lg:overflow-hidden ${
        skewCards.length > 6 ? "" : "lg:max-h-[720px]"
      }`}
    >
      <div className="relative custom-container mx-auto h-full">
        <div className="mx-auto lg:grid lg:grid-cols-12 xl:px-0 items-center xl:gap-24 gap-12">
          {/* Left Column → Client Cards */}
          {clients?.length > 0 && (
            <div className="lg:col-span-6 flex items-stretch">
              <div className="flex w-full py-4 text-center lg:text-left lg:py-[140px] flex-col gap-8">
                {/* Flexible Client Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 xl:gap-6">
                  {clients.map((client, idx) => (
                    <div
                      key={idx}
                      className="px-6 py-2 shadow-[0_4px_64px_rgba(0,0,0,0.06)]"
                    >
                      {client.label && (
                        <span className="text-sm text-[#d53333] uppercase font-semibold">
                          {client.label}
                        </span>
                      )}
                      {client.name && (
                        <h4 className="text-base 2xl:text-xl font-medium  text-[#272d57]">
                          {client.name}
                        </h4>
                      )}
                      {client.description && (
                        <p className="text-base 2xl:text-lg  text-[#272d57]">
                          {client.description}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
 
          {/* Right Column → Skewed Cards */}
          {skewCards?.length > 0 && (
            <div className="lg:col-span-6 flex items-stretch relative overflow-visible">
              <div className="lg:-ml-10 lg:block w-full">
                <div className="transform xl:-skew-x-24 lg:px-10">
                  {/* Always 2 cols if more than 1 card */}
                  <div
                    className={`grid ${
                      skewCards.length === 1 ? "grid-cols-1" : "grid-cols-2"
                    } gap-0`}
                  >
                    {skewCards.map((card, idx) => (
                      <div
                        key={idx}
                        className={`flex flex-col h-[240px] justify-center items-center text-center transition-all duration-300 p-6 py-2 hover:border-[#4B1D1D]/15 ${
                          idx % 2 === 0
                            ? "section-background-filler-2 border-r border-[#EDEDED]"
                            : "section-background-filler-2 border-l border-[#EDEDED]"
                        }`}
                      >
                        {card.title && (
                          <h4 className="transform xl:skew-x-24 text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-semibold text-[#272d57]">
                            {card.title}
                          </h4>
                        )}
                        {card.description && (
                          <p className="transform sm:max-w-xs xl:skew-x-24 text-sm sm:text-base xl:text-lg xl:font-medium text-[#272d57]">
                            {card.description}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
 
export default CaseStudiesSkewSatusCardsSection;